export default __webpack_public_path__ + "static/media/hamburger_menu_white.3dd691ef.svg";